import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// for new Order
const verifyDocument = createAsyncThunk(
  "verifyDocument",
  async (data, { rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/verifyDocument`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const getDocument = createAsyncThunk(
  "getDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/getDocument?sessionId=${data.sessionId}&currentTraveller=${data.currentTraveller}`,
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export { verifyDocument, getDocument };